import { type ComponentProps } from 'react'
import { Streamdown } from 'streamdown'

interface MarkdownContentProps {
  children: string
  isStreaming?: boolean
}

function Pre({ children }: ComponentProps<'pre'>) {
  return (
    <pre className="border-border bg-card dark:bg-background my-2 overflow-x-auto rounded-lg border p-3 text-xs [&>code]:bg-transparent [&>code]:p-0 [&>code]:text-xs">
      {children}
    </pre>
  )
}

export function MarkdownContent({ children, isStreaming = false }: MarkdownContentProps) {
  return (
    <Streamdown
      className="chat-markdown"
      animated
      isAnimating={isStreaming}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      components={{ pre: Pre as any }}>
      {children}
    </Streamdown>
  )
}
